<template>
  <div class="problems-reprints-page">
    <h1 class="reprints-title">Reprints</h1>
    <div class="search-bar">
      <div class="search-input-wrap">
        <div class="search-input-icon">
          <input v-model="searchArtId" id="searchArtId" placeholder="Art ID" class="search-input" />
          <button class="search-btn" @click="applySearch" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 
                3.09-.59 4.23-1.57l.27.28v.79l5 
                4.99c.41.41 1.09.41 1.5 
                0c.41-.41.41-1.09 0-1.5l-4.99-5zm-6 
                0C7.01 14 5 11.99 5 
                9.5S7.01 5 9.5 5s4.5 2.01 4.5 
                4.5S11.99 14 9.5 14z" />
            </svg>
          </button>
        </div>
      </div>
      <div class="search-input-wrap">
        <div class="search-input-icon">
          <input v-model="searchAdCode" id="searchAdCode" placeholder="Ad Code" class="search-input" />
          <button class="search-btn" @click="applySearch" tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 
                9.5A6.5 6.5 0 1 0 9.5 16c1.61 0 
                3.09-.59 4.23-1.57l.27.28v.79l5 
                4.99c.41.41 1.09.41 1.5 
                0c.41-.41.41-1.09 0-1.5l-4.99-5zm-6 
                0C7.01 14 5 11.99 5 
                9.5S7.01 5 9.5 5s4.5 2.01 4.5 
                4.5S11.99 14 9.5 14z" />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="table-scroll-wrap">
      <md-table>
        <md-table-row>
          <md-table-head>Art ID</md-table-head>
          <md-table-head>Ad Code</md-table-head>
          <md-table-head>Material</md-table-head>
          <md-table-head>Size</md-table-head>
          <md-table-head>Print Date</md-table-head>
          <md-table-head></md-table-head>
        </md-table-row>
        <md-table-row v-for="row in filteredRows" :key="row.id">
          <md-table-cell class="art-id-cell">{{ row.artId }}</md-table-cell>
          <md-table-cell class="ad-code-cell">{{ row.adCode }}</md-table-cell>
          <md-table-cell>
            <span class="material-capsule">{{ getMaterialName(row.material) }}</span>
          </md-table-cell>
          <md-table-cell>{{ row.size }}</md-table-cell>
          <md-table-cell>{{ row.printDate }}</md-table-cell>
          <md-table-cell>
            <md-button class="reprint-btn" @click="openReprintDialog(row)">Reprint</md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>

    <!-- Reprint Reason Modal -->
    <div v-if="showReprintDialog" class="modal-overlay" @click.self="closeReprintDialog">
      <div class="modal-box">
        <div class="modal-header">
          <h2>Choose a Reprint reason</h2>
          <button class="close-btn" @click="closeReprintDialog">×</button>
        </div>
        <div class="modal-body">
          <label for="reprint-reason">Reprint Reason</label>
          <select id="reprint-reason" v-model="selectedReprintReason" class="modal-select">
            <option disabled value="">Select reason</option>
            <option value="1">TCS expense</option>
            <option value="2">Andmore expense</option>
            <option value="Reprint Notes">Reprint Notes</option>
          </select>

          <label for="reprint-notes">Reprints Notes</label>
          <textarea id="reprint-notes" v-model="reprintNotes" rows="4" class="modal-textarea"></textarea>
        </div>
        <div class="modal-footer">
          <button class="confirm-btn" :disabled="!selectedReprintReason || !reprintNotes.trim()" @click="confirmReprint">Confirm</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'

export default {
  name: 'ProblemsReprintsPage',
  data() {
    return {
      searchArtId: '',
      searchAdCode: '',
      rows: [],
      materialsForDropdown: [],
      filteredRows: [],
      showReprintDialog: false,
      selectedReprintReason: '',
      reprintNotes: '',
      rowToReprint: null,
    };
  },
  async created() {
    await this.fetchReprintSponsorships();
    await this.fetchMaterialsForReprints();
    this.filteredRows = this.rows;
  },
  methods: {
    async fetchReprintSponsorships() {
      try {
        const response = await this.$axios.get(`/sponsorships?reprint=1&season_id=${Cookie.get('season_id')}`);
        this.rows = (response.data || []).map(item => ({
          id: item.sponsorships_id,
          artId: String(item.sponsorships_artwork),
          adCode: String(item.sponsorships_adspace),
          material: item.material_id,
          size: item.size,
          printDate: item.sponsorships_created_at ? this.formatDateUS(item.sponsorships_created_at.split(' ')[0]) : '',
        }));
      } catch (error) {
        console.error('Error fetching sponsorships:', error);
      }
    },
    async fetchMaterialsForReprints() {
      try {
        const response = await this.$axios.get('/materials', { params: { reprint: true } });
        this.materialsForDropdown = response.data || [];
      } catch (error) {
        console.error('Error fetching materials for reprints:', error);
      }
    },
    applySearch() {
      this.filteredRows = this.rows.filter(row => {
        const artMatch = this.searchArtId ? row.artId.includes(this.searchArtId) : true;
        const adMatch = this.searchAdCode ? row.adCode.includes(this.searchAdCode) : true;
        return artMatch && adMatch;
      });
    },
    openReprintDialog(row) {
      this.rowToReprint = row;
      this.selectedReprintReason = '';
      this.reprintNotes = '';
      this.showReprintDialog = true;
    },
    closeReprintDialog() {
      this.showReprintDialog = false;
      this.rowToReprint = null;
    },
    async confirmReprint() {
      if (!this.rowToReprint || !this.selectedReprintReason) return;
      try {
        let reasonToSend = this.selectedReprintReason;
        if (reasonToSend === '1' || reasonToSend === '2') {
          reasonToSend = Number(reasonToSend);
        }
        const payload = {
          reprint: true,
          sponsorships: [this.rowToReprint.id],
          reason: reasonToSend,
          notes: this.reprintNotes,
        };
        const response = await this.$axios.post('/sponsorship-print-tickets?market=3', payload);
        if (response.data && typeof response.data === 'string' && response.data.endsWith('.pdf')) {
          window.open(response.data, '_blank');
        }
        this.$mdToast.show(`Reprint ticket generated for Art ID: ${this.rowToReprint.artId}`);
        this.closeReprintDialog();
      } catch (error) {
        this.$mdToast.show('Failed to generate reprint ticket.');
        this.closeReprintDialog();
      }
    },
    getMaterialName(materialId) {
      const material = this.materialsForDropdown.find(m => m.id === materialId);
      return material ? material.name : materialId;
    },
    formatDateUS(dateStr) {
      if (!dateStr) return '';
      const [year, month, day] = dateStr.split('-');
      return `${month}/${day}/${year}`;
    },
  },
};
</script>

<style scoped>
/* --- Modal Styling --- */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.modal-box {
  background: #fff;
  border-radius: 10px;
  width: 450px;
  max-width: 90%;
  box-shadow: 0 6px 18px rgba(0,0,0,0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.modal-header {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
}
.modal-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}
.close-btn {
  border: none;
  background: transparent;
  font-size: 24px;
  cursor: pointer;
}
.modal-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.modal-body label {
  font-weight: 600;
}
.modal-select,
.modal-textarea {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 10px;
  font-size: 15px;
  width: 100%;
}
.modal-textarea {
  resize: vertical;
  min-height: 80px;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #eee;
}
.cancel-btn {
  background: transparent;
  border: 1px solid #aaa;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
}
.confirm-btn {
  background: #cd0a2f;
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
}
.confirm-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Reuse your table + search styles */
.table-scroll-wrap {
  width: 100%;
  overflow-x: auto;
  border: 2px solid #e3788c;
}
.md-table {
  min-width: 700px;
  border: none !important;
  box-shadow: none !important;
}
.art-id-cell, .ad-code-cell {
  color: #2e388c;
  font-weight: bold;
}
.reprint-btn {
  background: #cd0a2f !important;
  color: #fff !important;
  font-weight: bold;
  border: none;
  border-radius: 4px;
  padding: 6px 18px;
  min-width: 80px;
  cursor: pointer;
}
.reprint-btn:hover {
  background: #a00825 !important;
}
.problems-reprints-page {
  padding: 32px;
}

.reprints-title {
  margin-bottom: 24px;
}
.search-bar {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.search-input-wrap {
  flex: 1;
  min-width: 180px;
}
.search-input-icon {
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  padding: 0 4px 0 12px;
  height: 40px;
}
.search-input {
  border: none;
  outline: none;
  background: transparent;
  flex: 1;
  font-size: 16px;
}
.search-btn {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
}
.search-btn:hover {
  background: #e0e0e0;
}
/* Capsule style for material name - rounded, single-line text */
.material-capsule {
  display: inline-block;
  border: 2px solid #e3788c;
  border-radius: 9999px;
  padding: 4px 18px;
  font-weight: 500;
  font-size: 1em;
  line-height: 1.2;
  vertical-align: middle;
  background: #fff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
